/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { AttentionBeaconGroup } from '@bingads-webui-campaign-react/attention-beacon';
import { ActuationGroup } from '@bingads-webui-campaign-react/actuator';
import { useFormService } from '@bingads-webui-react/form';
import {
  FormErrorGroup,
  UnmappedFormErrors as OriginalUnmappedFormErrors,
} from '@bingads-webui-campaign-react/form-error';
import {
  apiErrorMapper,
} from '@bingads-webui-campaign-react/perf-max-step-wizard';
import { withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { StepHeader } from '@bingads-webui-campaign-react/pmax-common';
import { PANEL_KEYS } from '@bingads-webui-campaign-react/wizard-shared-components';
import { SystemErrors } from '@bingads-webui-campaign-react/unified-app-shared';

import { CampaignDetailsForm } from './campaign-details-form';

const UnmappedFormErrors = withControlErrorHandling(OriginalUnmappedFormErrors);

const ALL_SECTIONS_KEYS = [PANEL_KEYS.CAMPAIGN_NAME, PANEL_KEYS.AD_SCHEDULE, PANEL_KEYS.URL_OPTIONS];
const INITIALLY_EXPANDED_SECTIONS_KEYS = ALL_SECTIONS_KEYS;

export const CampaignDetailsStepShell = ({
  data,
  onDataChange,
  error,
}) => {
  const { serverErrors, systemErrors } = error || {};

  const { state } = useFormService();
  const { saveFailed } = state.context;

  return (
    <ActuationGroup actuationProps={{ isActive: saveFailed }}>
      <AttentionBeaconGroup>
        <FormErrorGroup formErrorProps={{
          errors: serverErrors, saveFailed, errorMapper: apiErrorMapper, showAllValidationErrors: saveFailed,
          }}
        >
          <div className="campaign-details-step-container">
            <StepHeader
              title={_TL_('Campaign details')}
              description={_TL_('Add your campaign information.')}
            />
            <UnmappedFormErrors className="other-server-errors" />
            <SystemErrors errors={systemErrors} />
            <CampaignDetailsForm
              data={data}
              onDataChange={onDataChange}
              allSectionsKeys={ALL_SECTIONS_KEYS}
              initiallyExpandedSectionsKeys={INITIALLY_EXPANDED_SECTIONS_KEYS}
            />
          </div>
        </FormErrorGroup>
      </AttentionBeaconGroup>
    </ActuationGroup>
  );
};

CampaignDetailsStepShell.propTypes = {
  data: PropTypes.shape({
    campaign: PropTypes.shape({}),
  }),
  error: PropTypes.shape({
    serverErrors: PropTypes.arrayOf(PropTypes.shape({})),
    systemErrors: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  onDataChange: PropTypes.func.isRequired,
};

CampaignDetailsStepShell.defaultProps = {
  data: {},
  error: {},
};
